import { useIntl } from 'react-intl';
import { CheckboxDefinitionType, ColumnDefinitionType } from '../genericTableTypes';
import { ReactComponent as FilterIcon } from '../../../../assets/image/filter_icon.svg';
import * as Styled from './style';
import InputCheckBox from '../../../FormElements/InputCheckBox';
import { ChangeEvent } from 'react';

type TableHeaderProps<T, K extends keyof T> = {
  id?: string;
  columns: ColumnDefinitionType<T, K>[];
  checkboxAll?: boolean;
  checkbox?: CheckboxDefinitionType;
  showCheckbox?: boolean;
  showMoreButton?: boolean;
  onFilterClick: (columnName: K) => void;
  className?: string;
};

const TableHeader = <T, K extends keyof T>({
  id,
  columns,
  checkboxAll,
  showCheckbox = false,
  showMoreButton = false,
  checkbox = { show: false, action: () => { } },
  onFilterClick,
  className
}: TableHeaderProps<T, K>) => {
  const intl = useIntl();
  const isMobile = window.innerWidth <= 960;
  const isCleaningTable = id === 'cleaning-executions' || id === 'cleaning-executions-tsi' || id === 'cleaning-executions-support';
  const getHeaderLabel = (header: string) => {
    if (!isMobile || !isCleaningTable) {
      return intl.formatMessage({ id: header });
    }

    if (header === 'equipment.Limpeza realizada') return intl.formatMessage({ id: 'equipment.Realizada' });
    if (header === 'equipment.Limpeza recomendada') return intl.formatMessage({ id: 'equipment.Recomendada' });
    if (header === 'equipment.Data da limpeza') return intl.formatMessage({ id: 'equipment.Data' });
    if (header === 'equipment.Hora da limpeza') return intl.formatMessage({ id: 'equipment.Hora' });

    return intl.formatMessage({ id: header });
  };

  return (
    <Styled.THeader id={id} className={className}>
      {showCheckbox &&
        (checkboxAll
          ?
          <Styled.Data width='2%' className='checkbox_all'>
            <div className='checkbox_text'>{intl.formatMessage({ id: 'menus.Selecionar todos' })}</div>
            <InputCheckBox
              name={`object-0`}
              id={`object-0`}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                checkbox.action(0, event.target.checked);
              }}
              isChecked={checkbox.selectedList?.includes(0)}
            />
          </Styled.Data>
          :
          <Styled.Data width='2%' className='checkbox_table' />)
      }
      {columns.map((column) => (
        <Styled.Data
          id={id}
          key={String(column.key)}
          width={column.width ? column.width : 'auto'}
          className={column.header !== ' ' && column.header !== 'home.Versão disponível' && column.header !== 'home.Versão instalada' && className !== 'serialNumbers-table' ? 'show' : 'hidden'}
        >
          <Styled.DataDiv className={`${(column.key === 'dateClean' || column.key === 'timestamp' || column.key === 'peakHours' || column.key === 'serialNumber') && 'showTooltip'}`}>
            {column.header?.trim() && column.key !== 'statusOnOff' ? getHeaderLabel(column.header) : ''}
            {column.isSortable && (
              <FilterIcon
                onClick={() => {
                  onFilterClick(column.key);
                }}
              />
            )}
            {(column.key === 'dateClean' || column.key === 'timestamp') && <Styled.Tooltip>{intl.formatMessage({ id: 'equipment.date format' })}</Styled.Tooltip>}
            {(column.key === 'serialNumber') && className !== 'serialNumbers-table' && <Styled.Tooltip>{intl.formatMessage({ id: 'equipment.Número de série' })}</Styled.Tooltip>}
            {(column.key === 'peakHours') && <Styled.Tooltip>{intl.formatMessage({ id: 'equipment.Horário de pico' })}</Styled.Tooltip>}
          </Styled.DataDiv>
        </Styled.Data>
      ))}
      {showMoreButton && <Styled.Data width='15px' />}
    </Styled.THeader>
  );
};

export default TableHeader;
